var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#362701;}\r\n\t.st1{fill:#F03C2E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_25_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_33_",
    className: "st0",
    d: "M286.2,225.7c-8,0-14,3.9-14,13.4c0,7.1,3.9,12.1,13.5,12.1c8.1,0,13.7-4.8,13.7-12.4 C299.5,230.2,294.5,225.7,286.2,225.7L286.2,225.7z M270.2,292.4c-1.9,2.3-3.8,4.8-3.8,7.7c0,5.8,7.4,7.6,17.6,7.6 c8.4,0,19.9-0.6,19.9-8.4c0-4.7-5.5-5-12.5-5.4L270.2,292.4L270.2,292.4z M313.3,226.1c2.6,3.3,5.4,8,5.4,14.7 c0,16.1-12.7,25.6-31,25.6c-4.7,0-8.9-0.6-11.5-1.3l-4.8,7.7l14.3,0.9c25.2,1.6,40,2.3,40,21.7c0,16.7-14.7,26.2-40,26.2 c-26.3,0-36.4-6.7-36.4-18.2c0-6.5,2.9-10,8-14.8c-4.8-2-6.4-5.7-6.4-9.6c0-3.2,1.6-6.1,4.2-8.9c2.6-2.8,5.5-5.5,9-8.7 c-7.1-3.5-12.5-11.1-12.5-21.8c0-16.7,11.1-28.2,33.3-28.2c6.3,0,10,0.6,13.4,1.5h28.4v12.4L313.3,226.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_36_",
    className: "st0",
    d: "M352.3,199.7c-8.3,0-13.1-4.8-13.1-13.1c0-8.3,4.8-12.8,13.1-12.8c8.4,0,13.2,4.5,13.2,12.8 C365.5,194.9,360.7,199.7,352.3,199.7z M333.5,287.1v-11.5l7.4-1c2-0.3,2.3-0.7,2.3-2.9v-42.8c0-1.6-0.4-2.6-1.9-3.1l-7.9-2.8 l1.6-11.8h30.1v60.4c0,2.3,0.1,2.6,2.3,2.9l7.4,1v11.5L333.5,287.1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_37_",
    className: "st0",
    d: "M432.5,281.4c-6.3,3.1-15.4,5.8-23.7,5.8c-17.3,0-23.9-7-23.9-23.4v-38.1c0-0.9,0-1.5-1.2-1.5 h-10.2v-12.9c12.8-1.5,17.9-7.9,19.5-23.7h13.8v20.7c0,1,0,1.5,1.2,1.5h20.5v14.5h-21.7V259c0,8.6,2,11.9,9.9,11.9 c4.1,0,8.3-1,11.8-2.3L432.5,281.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_38_",
    className: "st1",
    d: "M217,243.3l-66.5-66.5c-3.8-3.8-10-3.8-13.9,0l-13.8,13.8l17.5,17.5c4.1-1.4,8.7-0.5,12,2.8 c3.3,3.3,4.2,8,2.8,12.1l16.9,16.9c4.1-1.4,8.8-0.5,12.1,2.8c4.6,4.6,4.6,11.9,0,16.5c-4.6,4.6-11.9,4.6-16.5,0 c-3.4-3.4-4.3-8.5-2.5-12.7l-15.7-15.7l0,41.4c1.1,0.6,2.2,1.3,3.1,2.2c4.6,4.6,4.6,11.9,0,16.5c-4.6,4.6-12,4.6-16.5,0 c-4.6-4.6-4.6-12,0-16.5c1.1-1.1,2.4-2,3.8-2.5v-41.8c-1.4-0.6-2.7-1.4-3.8-2.5c-3.5-3.5-4.3-8.5-2.5-12.8L116,197.4L70.4,243 c-3.8,3.8-3.8,10,0,13.9l66.5,66.5c3.8,3.8,10,3.8,13.9,0l66.2-66.2C220.8,253.3,220.8,247.1,217,243.3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGit);
export default __webpack_public_path__ + "static/media/git.fff69573d1c741b67fee90c17414d27c.svg";
export { ForwardRef as ReactComponent };